import React from 'react'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import BackLink from '../../../components/Shared/BackLink'
import SaveButton from '../../../components/Shared/SaveButton'
import BorderlessInput from '../../../components/Shared/BorderlessInput'
import { update_user } from '../../../actions/auth'
import './index.scss'

class EditProfile extends React.Component {

  constructor(props) {
    super()
    const { user } = props
    this.state = {
      loading: false,
      form: {
        first_name: user.first_name,
        last_name: user.last_name,
        email: user.email,
        company: user.company
      }
    }
    this.handleChange = this.handleChange.bind(this)
    this.handleSubmit = this.handleSubmit.bind(this)
  }

  componentWillReceiveProps() {
    const { history } = this.props
    this.setState({ loading: false })
    history.push('/profile')
  }

  handleChange({ target }) {
    this.setState({
      form: {
        ...this.state.form,
        [target.name]: target.value
      }
    })
  }

  handleSubmit(e) {
    e.preventDefault()
    const { form } = this.state
    const { dispatch } = this.props
    this.setState({ loading: true })
    dispatch(update_user(form))
  }

  render() {
    const { form, loading } = this.state
    return (
      <div className='edit-profile-container'>
        <BackLink to='/profile' />
        <div className='edit-profile'>
          <h3>Edit Your Account Details</h3>
          <form method='post' onSubmit={this.handleSubmit}>
            <div className='input-container'>
              <BorderlessInput value={form.first_name} name='first_name'
                onChange={this.handleChange} label='First Name' required />
              <BorderlessInput value={form.last_name} name='last_name'
                onChange={this.handleChange} label='Last Name' required />
              <BorderlessInput value={form.email} name='email'
                onChange={this.handleChange} label='Your email' disabled={true} />
              <BorderlessInput value={form.company} name='company'
                onChange={this.handleChange} label='Your company (not mandatory)' disabled={true} />
            </div>
            <div className='save-button-container'>
              <SaveButton type='submit'>
                {loading ? 'Saving your profile...' : 'Save Account Details'}
              </SaveButton>
            </div>
          </form>
        </div>
      </div>
    )
  }
}

const mapStateToProps = ({auth}) => ({ user : auth.user })

export default withRouter(connect(mapStateToProps)(EditProfile))
